import React, { useState } from "react";
import { Upload } from "./upload";
import { PlyExportationTable } from "./ply-exportation-table";
import axios from "axios";

export const Main = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState();

  const updateData = async (
    index: number,
    mobileOrUid = "",
    options?: { silentRefresh?: boolean }
  ) => {
    if (!options?.silentRefresh) {
      setLoading(true);
      setData([]);
    }
    const { data } = await axios.get(
      `${process.env.API_PREFIX}/ply-exportations?page=${index}&mobileOrUid=${mobileOrUid}`
    );
    setData(data.data);
    setPageCount(data.pageCount);
    setLoading(false);
  };

  const loadData = async () => {
    updateData(0);
  };

  let logo = { src: "/assets/makeo-logo.svg", id: "app-logo" };

  if (process.env.NAME == "smilealigners") {
    logo = { src: "/assets/smile-aligners-logo.svg", id: "sa-app-logo" };
  }

  if (process.env.NAME == "zenyum") {
    logo = { src: "/assets/zenyum-logo.avif", id: "zy-app-logo" };
  }

  return (
    <div>
      <div className="flex items-center mb-6">
        <div id={logo.id} className="mr-4">
          <img src={logo.src} className=" w-[80%] h-[80px]" />
        </div>

        <h1 className="text-3xl font-bold tracking-tight">
          Upload Client File
        </h1>
      </div>
      <Upload onUpload={loadData} />
      <div>
        <PlyExportationTable
          data={data}
          isLoading={loading}
          pageCount={pageCount}
          handleChange={updateData}
        />
      </div>
    </div>
  );
};
